export const PROJECTS = [
  {
    id: "chaparide",
    index: "01",
    title: "CHAP A RIDE",
    subtitle: "Ride-Sharing Campaign",
    category: "Advertising",
    services: ["Campaign", "Poster Design", "Copywriting"],
    accent: "#F4CE2E",
    tile: "#F4CE2E",
    tileArt: { src: "/assets/img/tile-chap-a-ride.webp" },
    posters: [
      `/assets/img/chap-a-ride-raffle-ad-2.webp`,
      `/assets/img/chap-a-ride-raffle-ad-3.webp`,
      `/assets/img/chap-a-ride-travel-has-changed-1.webp`,
      `/assets/img/car-ad-3.webp`,
      `/assets/img/chap-a-ride-raffle-ad-1.webp`,
    ],
    description:
      "A launch campaign for Chap a Ride, the UK ride-sharing app, built on a single uncompromising yellow. Across five posters, disciplined art direction and sharp copywriting — \u201cYour empty seat just got interesting\u201d — turn an empty seat into a £500 prize draw, giving the brand a presence that is impossible to miss and even harder to forget.",
  },
  {
    id: "embellish",
    index: "02",
    title: "EMBELLISH",
    subtitle: "Catering Campaign",
    category: "Advertising",
    services: ["Campaign", "Poster Design", "Copywriting"],
    accent: "#B4CC8C",
    tile: "#B4CC8C",
    tileArt: { src: "/assets/img/tile-embellish.webp" },
    posters: [
      `/assets/img/embellish-milky-intro-advert.webp`,
      `/assets/img/embellish-milky2.webp`,
      `/assets/img/embellish-chicken-boards-purim.webp`,
      `/assets/img/embellish-meat-boards-purim.webp`,
      `/assets/img/embellish-phonebook.webp`,
    ],
    description:
      "A campaign for Embellish catering spanning the dairy line and festival entertaining — five posters in a restrained palette of black and sage. From \u201cThe new standard in dairy\u201d to Purim chicken and meat boards, each piece pairs considered art direction with assured copywriting, positioning Embellish as the natural choice for gatherings of every scale.",
  },
  {
    id: "kytchn",
    index: "03",
    title: "KYTCHN",
    subtitle: "Bespoke Kitchens — Brand Relaunch",
    category: "Advertising",
    services: ["Brand Campaign", "Poster Design", "Copywriting"],
    accent: "#C87A3B",
    tile: "#C87A3B",
    tileArt: { src: "/assets/img/tile-kytchn.webp" },
    posters: [
      `/assets/img/kytchn-intro-ad-2.webp`,
      `/assets/img/you-imagine-it-advert-1.webp`,
      `/assets/img/you-know-what-you-want-advert-2.webp`,
    ],
    description:
      "A relaunch campaign for Kytchn, specialists in bespoke kitchens and interiors. A wry spelling-bait series in beige and terracotta — \u201cYuo imgaine it. We trnalsate it.\u201d — establishes the new name with warmth and wit, making the point that the studio speaks design, not spelling.",
  },
  {
    id: "suited",
    index: "04",
    title: "SUITED LONDON",
    subtitle: "Menswear — Season Campaign",
    category: "Advertising",
    services: ["Season Campaign", "Poster Design", "Art Direction"],
    accent: "#B9B4A9",
    tile: "#F7F5F0",
    tileArt: { src: "/assets/img/tile-suited.webp" },
    posters: [
      `/assets/img/suited-london-sukkos-5787-2.webp`,
      `/assets/img/suited-london-men-s-suits.webp`,
      `/assets/img/suited-london-new-season.webp`,
    ],
    description:
      "A season campaign for Suited London menswear, presented in a disciplined monochrome palette. Three posters introduce the A/W \u201926 season, extended festival opening hours and the arrival of men\u2019s suits in store — tailoring communicated with the same precision the brand brings to its craft.",
  },
  {
    id: "furnisure",
    index: "05",
    title: "FURNISURE",
    subtitle: "Flexible Furnishing — Launch",
    category: "Advertising",
    services: ["Launch Ad", "Poster Design", "Copywriting"],
    accent: "#B02A30",
    posters: [`/assets/img/furnisure-furnish-faster-1.webp`],
    description:
      "Launch ad for Furnisure — flexible furnishing and appliances for HMOs, Airbnb and developments. \u201cFurnish faster. Let sooner.\u201d Grey velvet, brass and one decisive red.",
  },
  {
    id: "laser",
    index: "06",
    title: "LASER BY CHAVA",
    subtitle: "Anniversary Offer Campaign",
    category: "Advertising",
    services: ["Offer Campaign", "Poster Design", "Art Direction"],
    accent: "#D98A96",
    posters: [`/assets/img/laser-by-chava-anniversary-sale.webp`],
    description:
      "Anniversary campaign for Laser by Chava, Golders Green: two years, 30% off six sessions, hearts and pampas in dusty pink. Celebration, softly lit.",
  },
  {
    id: "rulop",
    index: "07",
    title: "RULOP",
    subtitle: "Nut Range Launch",
    category: "Advertising",
    services: ["Range Launch", "Poster Design", "Copywriting"],
    accent: "#8E1F3C",
    posters: [`/assets/img/rulop-nuts-launch.webp`],
    description:
      "Range launch for Rulop Foods: raw, roasted, salted, caramelised — \u201cWorth going nuts for.\u201d Big flavour, unbeatable price, shelf-ready confidence.",
  },
  {
    id: "raison-home",
    index: "05",
    title: "RAISON HOME",
    subtitle: "Bespoke Kitchens — Company Brochure",
    category: "Brochure Design",
    services: ["Brochure Design", "Art Direction"],
    accent: "#B9975B",
    tile: "#B9975B",
    tileArt: { src: "/assets/img/tile-raison.webp" },
    landscape: true,
    posters: [
      "/assets/work/raison-homes/page-01.jpg",
      "/assets/work/raison-homes/page-03.jpg",
      "/assets/work/raison-homes/page-04.jpg",
      "/assets/work/raison-homes/page-05.jpg",
      "/assets/work/raison-homes/page-06.jpg",
      "/assets/work/raison-homes/page-07.jpg",
      "/assets/work/raison-homes/page-08.jpg",
      "/assets/work/raison-homes/page-09.jpg",
      "/assets/work/raison-homes/page-10.jpg",
      "/assets/work/raison-homes/page-11.jpg",
      "/assets/work/raison-homes/page-12.jpg",
      "/assets/work/raison-homes/page-13.jpg",
      "/assets/work/raison-homes/page-14.jpg",
      "/assets/work/raison-homes/page-15.jpg",
      "/assets/work/raison-homes/page-16.jpg",
      "/assets/work/raison-homes/page-17.jpg",
      "/assets/work/raison-homes/page-18.jpg",
      "/assets/work/raison-homes/page-20.jpg",
    ],
    description:
      "A twenty-page company brochure for Raison Home Manchester, creators of bespoke kitchens across Europe since 1993. The publication leads readers through immersive VR visualisation, a fully managed design-and-installation process and genuine client testimonials — a piece crafted to win a client\u2019s confidence before the first meeting.",
  },
  {
    id: "relish",
    index: "06",
    title: "RELISH",
    subtitle: "Deli & Kitchen — Launch Campaign",
    category: "Poster Campaign",
    services: ["Campaign", "Poster Design", "Copywriting"],
    accent: "#F0752B",
    tile: "#F0752B",
    tileArt: { src: "/assets/img/tile-relish.webp" },
    posters: [
      `/assets/img/grand-opening-tomorrow.webp`,
      `/assets/img/relish-open-daily.webp`,
      `/assets/img/sandwich-ad-relish.webp`,
      `/assets/img/the-one-line-worth-waiting-in.webp`,
      `/assets/img/extended-opening-hours-relish.webp`,
    ],
    description:
      "A launch campaign for Relish, the Gateshead deli and kitchen. Five posters in the brand\u2019s uncompromising orange carry one voice across the grand opening, daily opening hours and the Shabbos favourites worth queueing for — bold type, honest appetite, no filler.",
  },
];

const CASE_IDS = ["chaparide", "embellish", "kytchn", "suited", "raison-home", "relish"];
export const CASE_STUDIES = PROJECTS.filter((p) => CASE_IDS.includes(p.id));
